import {deleteMethod, getMethod, postMethod} from '~/api'

async function remove(request) {
    return await deleteMethod('/proxy/customDocsCounter', request)
}

async function post(request) {
    return await postMethod('/proxy/customDocsCounter', request)
}

async function get(request) {
    return await getMethod('/proxy/customDocsCounter', request)
}

export {post, get, remove}
